// require('dotenv/config')

const jsonConfig = {
    urlReact: process.env.REACT_APP_FRONTEND,
    urlAPI: process.env.REACT_APP_BACKEND,
    APIKEY: `Bearer ${process.env.REACT_APP_APIKEY}`,
    limitDefault: 15,
    userMaster: "davi@netexperts.com.br"
}



export { jsonConfig }